import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { Region } from "../../types/entities";

export const useGetRegions = () =>
  useQuery({
    queryKey: ["regions"],
    queryFn: async (): Promise<Region[]> => {
      const resp = await fetchClient<Region[]>("/iam/region/");
      if (resp.error || !resp.data) throw resp.error || new Error("Failed to fetch Regions");
      return resp.data;
    },
    staleTime: 5 * 60 * 1000,
  });

export default useGetRegions;
